export const CALENDAR_START_HOUR = "06:00:00";
export const CALENDAR_START_HOUR_HHMM = "06:00";
export const CALENDAR_SLOT_DURATION = "00:30:00";
export const CALENDAR_SLOT_DURATION_MINUTES = 30;
export const TIME_PICKER_STEP_MINUTES = 15;
export const DAYS_PER_WEEK = 7;
export const TINY_DURATION_MS = 15 * 60 * 1000;

// Year ranges for the athlete wizard date pickers. These bound the year dropdown
// and the month-by-month paging alike.
export const BIRTHDATE_YEARS_BACK = 100;
export const ID_DOCUMENT_EXPIRATION_YEARS_AHEAD = 20;

// Year range for the staff wizard contract date pickers.
export const CONTRACT_DATE_YEARS_BACK = 10;
export const CONTRACT_DATE_YEARS_AHEAD = 10;
